import { render, staticRenderFns } from "./CollectDeposit.vue?vue&type=template&id=4347e592"
import script from "./CollectDeposit.vue?vue&type=script&lang=js"
export * from "./CollectDeposit.vue?vue&type=script&lang=js"
import style0 from "./CollectDeposit.vue?vue&type=style&index=0&id=4347e592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports